import { render, staticRenderFns } from "./SftpFileStatusUploads.vue?vue&type=template&id=498b3ab0&"
import script from "./SftpFileStatusUploads.vue?vue&type=script&lang=js&"
export * from "./SftpFileStatusUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports